import apiClient from './client';

export interface AuthUser {
  username: string;
}

export interface LoginResponse {
  success: boolean;
  token: string;
}

export interface VerifyResponse {
  success: boolean;
  user: AuthUser;
}

export const authApi = {
  login: async (username: string, password: string): Promise<LoginResponse> => {
    const response = await apiClient.post<LoginResponse>('/auth/login', { username, password });
    return response.data;
  },

  verify: async (): Promise<VerifyResponse> => {
    const response = await apiClient.get<VerifyResponse>('/auth/verify');
    return response.data;
  },
};
